import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, ShowProps, useDataProvider, useNotify } from "react-admin";
import { GridinRow, GridinRowsWithSpace, GridLabel } from "utils/style";
import { GetParam } from "utils/tools";
import IconPlus from "@material-ui/icons/Add";
import IconSave from "@material-ui/icons/Save";
import IconDelete from "@material-ui/icons/Delete";
import IconWarning from "@material-ui/icons/Warning";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import ParentAndPICSearchBox from "./components/ParentAndPICSearchBox";
import moment from "moment";
import _ from "lodash";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 650,
      padding: "1rem",
    },
    summaryButton: {
      position: "relative",
      top: 20,
      padding: "8px 16px",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 5,
      padding: theme.spacing(2, 4, 3),
    },
    submitButton: {
      marginLeft: 0,
      marginTop: 10,
    },
    input: {
      border: "1px solid #a6a6a6",
      padding: "5px 10px",
      borderRadius: 5,
    },
    pageWarning: {
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      color: "#f44336",
    },
  })
);

const SplitPayment = (props: ShowProps) => {
  const [paymentPercentages, setPaymentPercentage] = useState<
    IPaymentPercentage[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const provider = useDataProvider();
  const classes = useStyles();
  const notify = useNotify();
  const { id } = props;

  const getPaymentPercentages = () => {
    setLoading(true);
    provider
      .customGetListWithStaticParams(
        `students/${id}/paymentPercentages?Query.Filter=${JSON.stringify({})}`
      )
      .then(({ data }: any) => {
        setPaymentPercentage(
          _.orderBy(data, ["createdAt"]) as IPaymentPercentage[]
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    getPaymentPercentages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveNewPaymentPercantageLocally = useCallback(
    (data: IParent) => {
      setIsShowModal(false);

      const addedCheck = _.find(paymentPercentages, { parentId: data.id });
      const sameCompanyCheck = _.filter(paymentPercentages, (o) => {
        console.log("DEBGUG", {
          o,
          data,
          cond: o.parent.company?.id === data.company?.id,
        });
        return (
          o.parent.company?.id === data.company?.id &&
          o.parent.type !== "parent"
        );
      });

      if (addedCheck) {
        notify("Cannot add this Parent/PIC twice", "warning");
        return;
      }

      if (sameCompanyCheck.length !== 0) {
        notify("Cannot add PIC from same company twice", "warning");
        return;
      }

      setPaymentPercentage(
        _.orderBy(
          [
            ...paymentPercentages,
            {
              createdAt: moment().toString(),
              id: 0,
              isMain: false,
              parentId: data.id,
              parent: data,
              paymentPercentage: 0,
              studentId: Number(id),
              updatedAt: moment().toString(),
            },
          ],
          ["createdAt"]
        )
      );
    },
    [paymentPercentages, id]
  );

  const changeRowPercentage = useCallback(
    (value, parentId) => {
      const newPaymentPercentages = [...paymentPercentages];
      const updateTarget = _.find(newPaymentPercentages, { parentId });
      if (value >= 100) {
        updateTarget.paymentPercentage = 100;
      } else if (value <= 0) {
        updateTarget.paymentPercentage = 0;
      } else {
        updateTarget.paymentPercentage = Number(value);
      }
      setPaymentPercentage(newPaymentPercentages);
    },
    [paymentPercentages]
  );

  const removePaymentPercentageItem = useCallback(
    (parentId) => {
      const newPaymentPercentages = _.filter(
        paymentPercentages,
        (o: IPaymentPercentage) => {
          return o.parentId !== parentId;
        }
      );

      console.log("newPaymentPercentages", newPaymentPercentages);

      setPaymentPercentage(newPaymentPercentages);
    },
    [paymentPercentages]
  );

  const allowSave = useMemo(() => {
    const totalPercentage = _.sumBy(paymentPercentages, "paymentPercentage");

    return totalPercentage === 100;
  }, [paymentPercentages]);

  const savePaymentPercentage = useCallback(async () => {
    const formatted = _.map(paymentPercentages, (o: IPaymentPercentage) => {
      return {
        id: o.id === 0 ? undefined : o.id,
        parentId: o.parentId,
        studentId: Number(id),
        paymentPercentage: o.paymentPercentage,
      };
    });

    try {
      const result = await provider.customUpdate(
        `students/${id}/paymentPercentages`,
        {
          data: { parentStudentPaymentPercentages: formatted },
        }
      );
      getPaymentPercentages();
      notify("Split payment data updated successfully", "success");
    } catch (error) {
      console.log("ERR", error);
      notify(
        "Cannot save updated payment percentage, please try again",
        "warning"
      );
    }
  }, [paymentPercentages, id, getPaymentPercentages]);

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12} style={GridinRowsWithSpace}>
        <Typography variant="h6">Split Payment</Typography>
        {!allowSave && !loading && (
          <span className={classes.pageWarning}>
            <IconWarning /> Sum of All Payment Account is not 100%
          </span>
        )}
        <div>
          <Button
            onClick={() => setIsShowModal((prev) => !prev)}
            label="Add Parent or PIC"
          >
            <IconPlus />
          </Button>
          <Button
            disabled={!allowSave}
            onClick={savePaymentPercentage}
            label="Save"
          >
            <IconSave />
          </Button>
        </div>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Payment Account</TableCell>
                <TableCell>Percentage (%)</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paymentPercentages.length > 0 ? (
                <>
                  {paymentPercentages.map(
                    (paymentPercentage: IPaymentPercentage, key: number) => {
                      return (
                        <TableRow key={`percentage-${key}`}>
                          <TableCell>
                            <SanitizedGrid container spacing={2}>
                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Id :{" "}
                                  {paymentPercentage.parent
                                    ? `${paymentPercentage.parent.id}`
                                    : "-"}
                                </Typography>
                              </Grid>

                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Type :{" "}
                                  {paymentPercentage.parent.company
                                    ? `company`
                                    : paymentPercentage.parent.type}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Name :{" "}
                                  {paymentPercentage.parent
                                    ? `${paymentPercentage.parent.firstName} ${paymentPercentage.parent.lastName}`
                                    : "-"}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Email :{" "}
                                  {paymentPercentage.parent
                                    ? `${
                                        paymentPercentage.parent?.email ||
                                        paymentPercentage.parent?.user?.email ||
                                        "-"
                                      }`
                                    : "-"}
                                </Typography>
                              </Grid>
                            </SanitizedGrid>
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              className={classes.input}
                              value={paymentPercentage.paymentPercentage}
                              onChange={(e) => {
                                changeRowPercentage(
                                  e.target.value,
                                  paymentPercentage.parentId
                                );
                              }}
                            ></TextField>
                          </TableCell>
                          <TableCell>
                            {paymentPercentage.isMain === false && (
                              <Button
                                onClick={() =>
                                  removePaymentPercentageItem(
                                    paymentPercentage.parentId
                                  )
                                }
                                label="Remove"
                                style={{ backgroundColor: "#f44336" }}
                              >
                                <IconDelete />
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    {loading ? "Loading..." : "No results found."}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <AddParentOrPICModal
        onSubmit={(data: IParent) => {
          saveNewPaymentPercantageLocally(data);
        }}
        isShowModal={isShowModal}
        handleClose={() => {
          setIsShowModal(false);
        }}
      />
    </SanitizedGrid>
  );
};

interface AddParentOrPICModalProps {
  handleClose: () => void;
  isShowModal: boolean;
  onSubmit: (data: any) => void;
}

const AddParentOrPICModal = ({
  handleClose,
  isShowModal,
  onSubmit,
}: AddParentOrPICModalProps) => {
  const classes = useStyles();
  const [selected, setSelected] = useState<IParent | null>(null);

  const submitAction = useCallback(() => {
    onSubmit(selected);
  }, [selected]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={isShowModal}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isShowModal}>
        <div className={classes.paper}>
          <h2 id="transition-modal-title">Add Parent or PIC</h2>

          <ParentAndPICSearchBox onSelect={(value) => setSelected(value)} />

          <Button
            disabled={selected === null}
            className={classes.submitButton}
            onClick={submitAction}
            label="Add"
          >
            <IconPlus />
          </Button>
        </div>
      </Fade>
    </Modal>
  );
};

export default SplitPayment;
